import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ConfigProvider } from '@/providers/config-provider';
import { router } from '@/routes/routes';

// Single shared query client for the app. React Query owns all service reads;
// no component talks to the API directly (calls go through per-feature hooks
// wrapping `src/api/requester.ts`).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <ConfigProvider>
      <RouterProvider router={router} />
    </ConfigProvider>
  </QueryClientProvider>
);
